var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 14.7H15.0625M8.9375 17.4H12M9.8125 8.85H14.1875M12 11.1V6.6M18.125 3H5.875C5.64294 3 5.42038 3.09482 5.25628 3.2636C5.09219 3.43239 5 3.66131 5 3.9V20.1C5 20.3387 5.09219 20.5676 5.25628 20.7364C5.42038 20.9052 5.64294 21 5.875 21H18.125C18.3571 21 18.5796 20.9052 18.7437 20.7364C18.9078 20.5676 19 20.3387 19 20.1V3.9C19 3.66131 18.9078 3.43239 18.7437 3.2636C18.5796 3.09482 18.3571 3 18.125 3Z",
    stroke: "#1A130C",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.38e678610776b7c7cfab1bccfea27233.svg";
export { ForwardRef as ReactComponent };